import React from 'react';
import Color from '../../domain/Color';
import { t, props } from 'tcomb-react';

@props({
  goLogin: t.Func,
  goLoginLabel: t.Str,
  goProduct: t.maybe(t.Func),
  goProductLabel: t.maybe(t.Str),
  goCatalog: t.maybe(t.Func),
  goCatalogLabel: t.maybe(t.Str),
  color: t.maybe(Color),
  themeBtnColor: t.maybe(Color),
  themeBtnFontColor: t.maybe(Color)
})
export default class ResendPassword extends React.Component {

  getColorStyle() {
    if (!this.props.color) {
      return null;
    }
    return {
      color: this.props.color
    };
  };

  styleBtnColor() {
    return {
      backgroundColor: this.props.themeBtnColor,
      color: this.props.themeBtnFontColor
    };
  };

  goLogin = (evt) => {
    evt.preventDefault();
    this.props.goLogin();
  }

  goProduct = (evt) => {
    evt.preventDefault();
    this.props.goProduct();
  }

  goCatalog = (evt) => {
    evt.preventDefault();
    this.props.goCatalog();
  }

  goGoProductLink() {
    if (!this.props.goProduct) {
      return null;
    }
    //return (<a href='#' id='go_product' style={this.getColorStyle()} onClick={this.goProduct}>{this.props.goProductLabel}</a>);
    return (<button id='go_product' style={this.styleBtnColor()} onClick={this.goProduct}>{this.props.goProductLabel}</button>);
  }

  goGoCatalogLink() {
    if (!this.props.goCatalog) {
      return null;
    }

    let style = {
      ...this.styleBtnColor()
    }

    if (this.props.goProduct) {
      style.marginLeft = '20px'
    }
    //return (<a href='#' id='go_catalog' style={this.getColorStyle()} onClick={this.goCatalog}>{this.props.goCatalogLabel}</a>);
    return (<button id='go_catalog' style={style} onClick={this.goCatalog}>{this.props.goCatalogLabel}</button>);
  }

  goLoginLink() {
    if (!this.props.goLogin) {
      return null;
    }
    //return <a href="#" id="go_login" style={this.getColorStyle()} onClick={this.goLogin}>{this.props.goLoginLabel}</a>
    return <button id="go_login" style={this.styleBtnColor()} onClick={this.goLogin}>{this.props.goLoginLabel}</button>
  }

  render() {
    return (
      <div id="header">
        <div className="cols">
          <div className='large-70'>
            <div className='cell'>
              {this.goGoProductLink()}
              {this.goGoCatalogLink()}
            </div>
          </div>
          <div className='large-30 large-text-right'>
            <div className='cell'>
               {this.goLoginLink()}
            </div>
          </div>
        </div>
      </div>
    );
  }
}




/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/components/header/ResendPassword.js
 **/